import FormPrototype from '@/models/FormPrototype';
import { useStore } from 'vuex';

export default function useSetInitialLensSide()
{
    const store = useStore();

    /**
     * Handler for setting an initial "LENS_SIDE" parameter value.
     */
    class SetInitialLensSide
    {
        side = 'single';

        /**
         * @param {"right"|"left"|"single"} side
         */
        constructor(side)
        {
            if(!['right', 'left', 'single'].includes(side))
            {
                throw new TypeError(`Invalid value for side: "${side}"`);
            }

            this.side = side;
        }

        async handle()
        {
            const side = this.side;
            /** @type {FormPrototype?} */
            const proto = store.getters['lensOrder/getPrototype'](side);

            if(!proto)
            {
                console.log(`No prototype on ${side} side.`);
                return true;
            }

            console.log(`Setting LENS_SIDE = "${side}".`);
            proto.setValue('LENS_SIDE', side, {
                form_display:          'HIDDEN',
                form_splitted_display: 'HIDDEN',
            });
            return true;
        }
    }

    return SetInitialLensSide;
};
